export interface ProcessStep {
    s_no?: number;
    pcstepId: number;
    pcstepName: string;
    pcsteppos: string;
    status: number;
}

export const defaultProcessStep: ProcessStep = {
    pcstepId: 0,
    pcstepName: '',
    pcsteppos: '',
    status: 0
};
